import React from "react";
import { Container, Card, Col, Row, Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FaDownload } from "react-icons/fa";
import moment from "moment";
import { saveAs } from "file-saver";

const ListChats = ({onChangeLoadPage, items, expediente}) => {


  const onChangeLoadPageTrazability = (obj) => {
    onChangeLoadPage(obj);  
   };

  const createFile =() => {
     var texto='';
     const myVal = items.map(item => {
      texto = '\n'+'DE:'+ item.typeUser +' '+'FECHA:'+ item.when + ' ' + 'MENSAJE:'+ item.body ;
     return texto 
   })

    var today = moment(new Date()).format("DD-MM-YYYY")
    var filename = `chat_${expediente ? expediente : 'sinexpediente'}_${today}.txt`
    const blob = new Blob ([myVal],{type:'text/plain;charset=utf-8'})
    saveAs (blob,filename)
  }

  return (
    <>
      <Container className="my-5">
        <h2 className="mb-0 title-top">Chats</h2>

        <Card className="shadow-1 mt-3 padding-card-general">
          <Card.Body className="position-relative">
            {
              items.map((item, i)=>(
                <div className="box-chat" key={i}>
                    <small className="text-muted d-block font-size-08rem">
                    {`${expediente ? expediente : 'sin expediente'} - ${moment(item.when, "MM/DD/YYYY HH:mm:ss").format("MM DD YYYY HH:mm")}`}
                    </small>
                    <h6 className={(item.typeUser ===`USER_1`) ? `card-title mb-1 text-blue-2` : `card-title mb-1 color-second`}>
                      {item.typeUser}                      
                    </h6>
                    <p>{item.body}</p>
                </div>
              ))
            }

            <span 
              className="cursor-pointer text-action color-action-download mx-2 d-block text-center"
              onClick={createFile}>
              <FaDownload className="color-action-download" /> Descargar Conversación
            </span>


          </Card.Body>
        </Card>
        <Row className='mt-3'>
          <Col className="text-right">
            <Button type="button" variant="danger" className="cancelar-buttom" onClick={() => {onChangeLoadPageTrazability({view: "trazabilidad"})}}>Regresar</Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default withTranslation()(ListChats);
